import { Component } from '@angular/core';
import { AppComponent } from '../../../app.component';
import { Router, Event, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';
import moment from 'moment';

@Component({
    selector: 'app-footer',
    templateUrl: './app.footer.component.html',
    styleUrls: ['./app.footer.component.scss'],
    standalone :false,
})
export class AppFooterComponent {
    currentRoute: string = "";
    currentYear: any = moment().year();
    constructor(public app: AppComponent, private router: Router) {
        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                let url = event.url;
                this.currentRoute = url.replace('/', '');
            }
        });
    }
}
